import '../sass/cutout-media-accordion.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const detailsScript = document.querySelector('#ofg-education-details-js');
    const $blocks = document.querySelectorAll('.block.cutout-media-accordion');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $mediaCarousel = $block.querySelector('.cutout-media-accordion__media-carousel');
        const $accordions = $block.querySelectorAll('.cutout-media-accordion__accordion');
        const $mediaBackground = $block.querySelector('.cutout-media-accordion__media-background');
        const $slides = $block.querySelectorAll('.swiper-slide');

        let mediaCarousel, accordions = [];

        const initDetails = () => {
            if ($accordions) {
                $accordions.forEach(($accordion, index) => {
                    const accordion = new Details($accordion, {
                    });

                    accordions.push(accordion);

                    $accordion.addEventListener('detailsopen', () => {
                        const closedAccordions = accordions.filter((accordion, closeAccordionIndex) => closeAccordionIndex !== index);

                        closedAccordions.forEach(accordion => {
                            accordion.close();
                        });

                        mediaCarousel?.slideTo(index);
                    });
                });
            }
        };

        const initCarousel = () => {
            if ($mediaCarousel) {
                mediaCarousel = new Swiper($mediaCarousel, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                });

                mediaCarousel.on('slideChange', () => {
                    if (!$slides[mediaCarousel.activeIndex]) return;

                    const { backgroundColour } = $slides[mediaCarousel.activeIndex].dataset;

                    if (!backgroundColour) return;

                    $mediaBackground.classList.remove('cutout-media-accordion__media-background--black');
                    $mediaBackground.classList.remove('cutout-media-accordion__media-background--green');
                    $mediaBackground.classList.remove('cutout-media-accordion__media-background--dark-green');
                    $mediaBackground.classList.remove('cutout-media-accordion__media-background--pink');
                    $mediaBackground.classList.remove('cutout-media-accordion__media-background--light-blue');
                    $mediaBackground.classList.add(`cutout-media-accordion__media-background--${backgroundColour}`);
                });
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }

        if (typeof Details !== 'undefined') {
            initDetails();
        } else if (detailsScript) {
            detailsScript.addEventListener('load', () => {
                initDetails();
            });
        } else {
            window.addEventListener('load', () => {
                const detailsScript = document.querySelector('#ofg-education-swiper-js');

                if (!detailsScript) return;

                initDetails();
            });
        }
    });
})();
